module.exports = __webpack_public_path__ + "media/application/images/icons/insights-explorer-3607cadca452e1a947e50d2b9e06a2e4.svg";